import React from 'react'
import Helmet from 'react-helmet'

const SchemaOrgJSONLD = ({
  postUrl,
  postTitle,
  publishDate,
  updatedAt,
  author,
  description,
  imageUrl,
}) => {
  const schemaOrgJSONLD = {
    '@context': 'http://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': postUrl,
    },
    headline: postTitle,
    image: [imageUrl],
    datePublished: publishDate,
    dateModified: updatedAt,
    author: {
      '@type': 'Person',
      name: author,
    },
    publisher: {
      '@type': 'Organization',
      name: 'SMARTY',
      logo: {
        '@type': 'ImageObject',
        url: 'https://smarty.co.uk/assets/images/smarty_logo.png',
      },
    },
    description: description,
  }

  return (
    <Helmet>
      {/* Schema.org tags */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script>
    </Helmet>
  )
}

export default SchemaOrgJSONLD
